import {
  AvailableCompanionTabs,
  useCompanion,
} from "@hooks/use-companion";
import { useCompanionV2 } from "@hooks/use-companion-v2";
import { useCallback } from "react";

export function useStartCompanionChat() {
  const { expandSidebar, setCompanionSession, setActiveTab } =
    useCompanion();
  const {
    clearSession: clearV2Session,
    isCreatingSession: isCreatingV2Session,
  } = useCompanionV2();

  const startChat = useCallback(() => {
    expandSidebar();
    setCompanionSession(null);
    setActiveTab(AvailableCompanionTabs.chat);
    clearV2Session();
  }, [
    expandSidebar,
    setCompanionSession,
    setActiveTab,
    clearV2Session,
  ]);

  return {
    startChat,
    isStarting: isCreatingV2Session,
  };
}
